<script>
import ElTabPane from 'element-ui/packages/tabs/src/tab-pane'

/**
 * 继承 Element TabPane 本体，使 $parent 始终是 UiTabs（ElTabs 子类）。
 */
export default {
  // Element Tabs 在运行时硬编码检查 ElTabPane；业务标签名由全局注册器提供。
  name: 'ElTabPane',
  extends: ElTabPane
}
</script>
